import {Tab, Tabs} from "@mui/material";
import {TabWrapper} from "../TabWrapper";
import React from "react";
import {showNumber} from "../pricing/Pricing";
import {useProject} from "../ProjectName";
import {useAlternative} from "../../quote/alternative/Alternative";
import {Project} from "../../../../api/Projects";
import {PriceDetail} from "../../quote/UnPricedItems";

export const defaultDiv10Tab = "wr-accessory"
export type TDiv10Type = "corner-guard" | "locker" | "mailbox" | "wr-accessory" | "wr-partition"

export function Div10Tabs(props: {
    unpriced?: PriceDetail;
    accessories?: boolean;
    tab: string;
    onChange(value: TDiv10Type): void;
}) {
    const proj = useProject();
    const alt = useAlternative();

    return (
        <TabWrapper>
            <Tabs value={props.tab} onChange={(e, value) => props.onChange(value)}>
                {div10TabKeys.filter(k => {
                    if(props.accessories === false) return k !== "wr-accessory"
                    return true;
                }).map(k =>
                    <Tab key={k} label={
                        <>{showNumber(Div10TypeToName(k), props.unpriced?.div10Detail[k].unpriced)}{isLocked(k, proj, alt) ? " 🔒" : ""}</>} value={k} />
                )}
            </Tabs>
        </TabWrapper>
    )
}

function isLocked(k: TDiv10Type, proj: Project|null|undefined, alt: number) {
    if(!proj) return false;
    if(!alt) return false;

    if(k === "wr-accessory" && proj.quoteLockedDiv10WrAccessories === alt) return true
    if(k === "wr-partition" && proj.quoteLockedDiv10WrPartitions === alt) return true
    if(k === "locker" && proj.quoteLockedDiv10Lockers === alt) return true
    if(k === "mailbox" && proj.quoteLockedDiv10Mailboxes === alt) return true
    if(k === "corner-guard" && proj.quoteLockedDiv10CornerGuards === alt) return true
    return false;
}

export const div10TabKeys: TDiv10Type[] = [
    "wr-accessory",
    "wr-partition",
    "locker",
    "mailbox",
    "corner-guard",
];

// keep in sync with product/main.go:Div10TypeToName
export function Div10TypeToName(input: string) {
    switch(input) {
        case "wr-accessory": return "W/R Accessories";
        case "wr-partition": return "W/R Partitions";
        case "locker": return "Lockers";
        case "mailbox": return "Mailboxes";
        case "corner-guard": return "Corner Guards";
        default:
            return "UNKNOWN";
    }
}